var React = require('react');

function FacebookFooter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.667 0a6.667 6.667 0 100 13.334A6.667 6.667 0 006.667 0zM8.64 3.922h-.932c-.329 0-.398.135-.398.475v.822h1.33l-.128 1.443H7.311v4.312H5.589V6.681h-.895V5.219h.895V4.068c0-1.08.578-1.644 1.859-1.644H8.64v1.498z"}));
}

FacebookFooter.defaultProps = {"width":"13.333","height":"13.333","viewBox":"0 0 13.333 13.333"};

module.exports = FacebookFooter;

FacebookFooter.default = FacebookFooter;
